!(function () {
  const t = (e) => {
    let t;
    e = +(t = document.currentScript
      ? document.currentScript.parentElement.querySelector(
          ".featured-collections__swiper"
        )
      : e.querySelectorAll(".featured-collections__swiper")).getAttribute(
      "data-slides"
    );
    let r, n, i;
    (r =
      1 == e
        ? ((i = e), (n = e))
        : 2 == e
        ? ((i = 1.5), (n = 2))
        : ((i = 1.5), (n = 2.5), 3)),
      t &&
        new Swiper(t, {
          spaceBetween: 8,
          navigation: {
            prevEl: t.parentNode.querySelector(".swiper-button-prev"),
            nextEl: t.parentNode.querySelector(".swiper-button-next"),
          },
          slidesPerView: i,
          breakpoints: {
            576: { slidesPerView: n },
            1024: { slidesPerView: r },
          },
        });
  };
  t(),
    document.addEventListener("shopify:section:load", function (e) {
      t(e.target);
    }),
    document.addEventListener("shopify:section:reorder", function (e) {
      t(e.target);
    });
})();
